import hintTemplateNames from './hintTemplateNames';

// @vue/component
export default {
  name: 'PopupHints',

  components: {
    users: () => import('./HintsTemplates/UsersViewHint.vue'),
    start: () => import('./HintsTemplates/StartViewHint.vue'),
    widgets: () => import('./HintsTemplates/WidgetsViewHint.vue'),
    websites: () => import('./HintsTemplates/WebsitesViewHint.vue'),
    blackList: () => import('./HintsTemplates/BlackListViewHint.vue'),
    connections: () => import('./HintsTemplates/ConnectionsViewHint.vue'),
    departments: () => import('./HintsTemplates/DepartmentsViewHint.vue'),
    expiredAccess: () => import('./HintsTemplates/ExpiredAccessAlert.vue'),
    promotionCodes: () => import('./HintsTemplates/PromotionCodesViewHint.vue'),
    permissions: () => import('./HintsTemplates/PermissionProfilesViewHint.vue'),
    agentsAndNumbers: () => import('./HintsTemplates/AgentsAndNumbersViewHint.vue'),
  },
  props: {
    hintTemplateName: {
      type: String,
      default: 'widgets',
      validator: value => hintTemplateNames.names.some(templateValue => value === templateValue.name),
    },
  },

};
